module.exports = __webpack_public_path__ + "static/2.1_the_earliest_human_societies-29ddbd7ac569691a4d354afa749a2443.pdf";